<template>
  <div class="message-filter">
    <div class="message-filter-bar">
      <z-input
        v-model="keywordModel"
        clearable
        placeholder="搜索"
        :prefix-icon="Search"
      />
      <z-button
        :icon="Plus"
        circle
        aria-label="发起群聊"
        @click="emit('create-group')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Plus, Search } from '@zoryn/icons'
import ZButton from '@zoryn/components/button'
import ZInput from '@zoryn/components/input'
import '@zoryn/components/button/style'
import '@zoryn/components/input/style'

const props = defineProps<{
  keyword: string
}>()

const emit = defineEmits<{
  'update:keyword': [value: string]
  'create-group': []
}>()

const keywordModel = computed({
  get: () => props.keyword,
  set: (value) => emit('update:keyword', value),
})
</script>
